export const testimonials = [
  {
    id: 1,
    name: "Marcus Chen",
    role: "First-time Buyer",
    image: "https://i.pravatar.cc/150?img=12",
    content: "I saved $4,200 on my new SUV using Auto Shark's tactics. The dealership tried every trick in the book, but I was ready.",
    savings: 4200
  },
  {
    id: 2,
    name: "Sarah Martinez",
    role: "Traded In & Upgraded",
    image: "https://i.pravatar.cc/150?img=45",
    content: "The consultation was worth every penny. They showed me exactly when to negotiate and what to say. Saved $3,800!",
    savings: 3800
  },
  {
    id: 3,
    name: "David Park",
    role: "Luxury Car Buyer",
    image: "https://i.pravatar.cc/150?img=33",
    content: "Auto Shark's strategies work on luxury dealers too. I thought I was getting a good deal until I used their eBook tactics.",
    savings: 6500
  }
];

export const faqs = [
  {
    id: 1,
    question: "How much can I really save using Auto Shark?",
    answer: "Our customers typically save $2,000-$6,000 per vehicle purchase. The exact amount depends on the car type, market conditions, and how effectively you apply our strategies. Some customers have saved over $10,000 on luxury vehicles."
  },
  {
    id: 2,
    question: "Do these tactics work at any dealership?",
    answer: "Yes! Our strategies are based on universal dealership practices and negotiation psychology. Whether you're buying from a small local dealer or a large franchise, these tactics give you the upper hand."
  },
  {
    id: 3,
    question: "What's included in the free Calendar?",
    answer: "The 'Best Time to Buy Calendar' reveals the exact days, weeks, and months when dealerships are most motivated to negotiate. It includes sales cycles, quota periods, and insider timing secrets that can instantly improve your bargaining position."
  },
  {
    id: 4,
    question: "Is the consultation done remotely or in-person?",
    answer: "Consultations are conducted via video call for your convenience. We'll review your specific situation, target vehicle, local market, and create a personalized negotiation strategy. You'll walk away with a clear action plan."
  },
  {
    id: 5,
    question: "How is Auto Shark different from other car-buying advice?",
    answer: "We're former dealership insiders who've flipped the script. Instead of generic tips, you get battle-tested tactics that exploit how dealerships actually operate—from financing tricks to hidden fees. We show you exactly what they don't want you to know."
  }
];

export const features = [
  {
    id: 1,
    title: "Clarity",
    description: "Understand exactly what you're paying for—no hidden fees, no confusing jargon. We decode dealership language.",
    icon: "eye"
  },
  {
    id: 2,
    title: "Confidence",
    description: "Walk into any dealership knowing you have the power. Our tactics give you the psychological edge.",
    icon: "shield"
  },
  {
    id: 3,
    title: "Strategy",
    description: "Every move calculated. From timing to talking points, you'll have a proven game plan for maximum savings.",
    icon: "target"
  }
];

export const tactics = [
  {
    id: 1,
    title: "The End-of-Month Leverage",
    description: "Learn when salespeople are desperate to hit quotas and how to exploit this pressure for better deals."
  },
  {
    id: 2,
    title: "Finance Office Defense",
    description: "Defend against the F&I manager's upsells and add-ons that can cost you thousands in seconds."
  },
  {
    id: 3,
    title: "The Walk-Away Close",
    description: "Master the art of walking away—and when to do it for maximum impact on price negotiations."
  },
  {
    id: 4,
    title: "Trade-In Value Maximization",
    description: "Prevent lowball offers on your trade-in and extract every dollar of real market value."
  }
];

export const stats = [
  {
    id: 1,
    value: "$4,200",
    label: "Average Customer Savings"
  },
  {
    id: 2,
    value: "15,000+",
    label: "Smart Buyers Empowered"
  },
  {
    id: 3,
    value: "97%",
    label: "Success Rate"
  }
];